<template>
  <div class="content">
    <!-- SHOW LOCKSCREEN -->
    <div id="lessonLockScreen" v-if="!isLoading && data.status.locked">
      <h1 class="largeTitle blueTitle">We're sorry, this content is not available to you yet</h1>
      <mu-icon value="lock"/>
      <p>This lesson is not available to you for another {{data.status.remaining}} day(s)</p>
      <mu-raised-button class="btnRedirect" label="Go to Dashboard" @click.native="goToDashboard"/>
    </div>

    <!-- SHOW LOADING SCREEN -->
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="48"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>

    <div v-if="!isLoading && data.status.locked === false">
      <lesson-rating-panel
        v-if="!data.taken.start_questions"
        class="marginBottom" mode="start"
        :course="data"
      ></lesson-rating-panel>
      <mu-content-block style="padding-left: 0; padding-right:0">
        <div class="title">
          <h1 v-text="data.title"></h1>
        </div>
      </mu-content-block>


      <lesson-personalised-panel
        :course="data"
        :courseId="data.course_id"
        @isMainVideoVisible="toggleMainVideo"
      ></lesson-personalised-panel>

      <mu-card v-if="isMainVideoVisible">
        <iframe-video-player
          :src="data.videos.vimeo.web"
        ></iframe-video-player>
      </mu-card>

      <mu-card class="bottom">
        <mu-card-text>
          <p v-html="$sanitize(data.content)"></p>
          <audio-player
            v-if="data.audio_url"
            :url="data.audio_url"
            class="bottom"
          ></audio-player>
          <mu-raised-button
            @click.native="toggleTranscript"
            :icon="isTranscriptOpen ? 'expand_less': 'expand_more'"
            :label="isTranscriptOpen ? $t('message.lessonHideTranscript') :  $t('message.lessonViewTranscript')"
            primary
          />
        </mu-card-text>
      </mu-card>
      <mu-card class="marginBottom removeBrs" v-if="isTranscriptOpen">
        <mu-card-text v-html="$sanitize(data.transcript)"></mu-card-text>
        <mu-card-actions align="right">
          <mu-raised-button @click.native="isTranscriptOpen = false">{{$t('message.closeText')}}</mu-raised-button>
        </mu-card-actions>
      </mu-card>
      <mu-card id="action_points" class="bottom">

        <mu-card-header
          titleClass="blueTitle largeTitle"
          :title="$t('message.lessonActionPoints')"
          :subTitle="$t('message.lessonActionPointsSubTitle')">
        </mu-card-header>

        <iframe-video-player
          :src="data.videos.vimeo_ap.web"
        ></iframe-video-player>

        <mu-card-text id="actionList">
          <div v-for="action, index in data.action_points" :key="'action-' + index" class="action">
            <div class="title" v-text="action.title"></div>
            <div v-html="$sanitize(action.action)"></div>
          </div>
        </mu-card-text>
      </mu-card>

      <lesson-rating-panel
        class="bottom"
        mode="end"
        :course="data"
      ></lesson-rating-panel>

      <mu-row v-if="data.quiz.length > 0">
        <mu-col width="100" desktop="100" tablet="100">
          <lesson-quiz-panel
            :quiz="data.quiz"
            :course_id="data.course_id"
            :quiz_id="data.quiz_id"></lesson-quiz-panel>
        </mu-col>
      </mu-row>
      <mu-row :gutter="true" style="margin-top: 24px;">

        <mu-col desktop="100" tablet="100" width="100">
          <lesson-downloads-panel
            class="bottom"
            :downloads="data.downloads"
          ></lesson-downloads-panel>
        </mu-col>

        <mu-col desktop="100" tablet="100" width="100">
          <lesson-questions-panel
            :course-id="data.course_id"
          ></lesson-questions-panel>
        </mu-col>

      </mu-row>
    </div>
  </div>
</template>
<script>
  import HCPMixin from '../../mixins/HCPMixin';
  import LessonsApi from '../../api/Lessons/index'
  import CheckInApi from '../../api/CheckIn'


  import LessonQuestionsPanel from "../../components/Lesson/QuestionsPanel/QuestionsPanel.vue";
  import LessonDownloadsPanel from "../../components/Lesson/DownloadsPanel/DownloadsPanel.vue";
  import LessonQuizPanel from "../../components/Lesson/QuizPanel/QuizPanel.vue";
  import TitleManager from '../../helpers/TitleManager'
  import LessonRatingPanel from "../../components/Lesson/RatingPanel/RatingPanel.vue";
  import AudioPlayer from "../../components/AudioPlayer/AudioPlayer.vue";
  import IframeVideoPlayer from "../../components/IframeVideoPlayer/IframeVideoPlayer.vue";
  import LessonPersonalisedPanel from "../../components/Lesson/PersonalizedPanel/PersonalizationPanel.vue";

  export default {
    components: {

      IframeVideoPlayer,
      AudioPlayer,
      LessonRatingPanel,
      LessonQuizPanel,
      LessonDownloadsPanel,
      LessonQuestionsPanel,
      LessonPersonalisedPanel,
    },
    name: 'lesson',
    data() {
      return {
        data: {},
        isMainVideoVisible: true,
        isTranscriptOpen: false,
        isLoading: true,
        checkInStatus: {}
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/lesson');
      if(self.$store.state.status.payment.paid === false) {
        self.$router.push({name: 'Dashboard'});
      }
      TitleManager.setTitle(this.$t('message.loadingText'));
      LessonsApi.getLessonByPermalink(self.$route.params.permalink)
        .then(function (response) {
          self.data = response.data;
          self.isLoading = false;
          TitleManager.setTitle(self.data.title);
          if (_.has(self.$store.state.user.scope, 'date_joined')) {
            let days = 7,
              now = moment(),
              futureDays = moment(self.$store.state.user.scope.date_joined).add('days', days);
            if (now >= futureDays) {
              if(!self.isHcpUser) {
                self.getCheckInStatus();
              }
            }
          }
        })
    },
    methods: {
      getCheckInStatus() {
        let self = this;
        CheckInApi.getCheckInStatus()
          .then(function (response) {
            self.checkInStatus = response.data;
            self.$nextTick(function () {
              if (window.sessionStorage.getItem('checkInIgnored')) {}
              else {
                let needsCheckIn = self.checkInStatus.isDiabetic
                  ? (self.checkInStatus.weightNeedsCheckIn || self.checkInStatus.hba1cNeedsCheckin || self.checkInStatus.hba1cNeedsCheckIn)
                  : self.checkInStatus.weightNeedsCheckIn;
                if (needsCheckIn) {
                  // Remember the lesson so the check-in returns here when finished
                  // instead of dropping the user on the Dashboard.
                  window.sessionStorage.setItem('checkInRedirect', self.$route.fullPath);
                }
                if (self.checkInStatus.isDiabetic === true) {
                  if (self.checkInStatus.weightNeedsCheckIn === true && self.checkInStatus.hba1cNeedsCheckin === true) {
                    self.$router.push({
                      name: 'Hba1cCheckin',
                      query: {
                        diabetic: true,
                        hba1c: true,
                        weight: true
                      }
                    })
                  }
                  else {
                    if (self.checkInStatus.hba1cNeedsCheckIn === true) {
                      self.$router.push({
                        name: 'Hba1cCheckin',
                        query: {
                          diabetic: true,
                          hba1c: true,
                          weight: false
                        }
                      })
                    }
                    if (self.checkInStatus.weightNeedsCheckIn === true) {
                      self.$router.push({
                        name: 'WeightCheckin',
                        query: {
                          diabetic: true,
                          weight: true,
                          hba1c: false
                        }
                      })
                    }
                  }
                }
                else {
                  if (self.checkInStatus.weightNeedsCheckIn === true) {
                    self.$router.push({
                      name: 'WeightCheckin',
                      query: {
                        diabetic: false,
                        weight: true,
                        hba1c: false
                      }
                    })
                  }
                }
              }
            })
          });
      },
      toggleMainVideo(value) {
        let self = this;
        self.isMainVideoVisible = value;
      },
      goToDashboard() {
        let self = this;
        self.$router.push({
          name: 'Dashboard'
        })
      },
      toggleTranscript() {
        let self = this;
        self.isTranscriptOpen = !self.isTranscriptOpen;
      }
    }
  }
</script>
<style lang="less" scoped>

  #lessonLockScreen {
    margin: 20px 0 0;
    font-size: 15px;
    color: #4A4A4A;
    text-align: center;
    .mu-icon {
      margin: 10px 0 0;
      font-size: 50px;
    }
  }

  .btnRedirect {
    padding: 20px;
    margin: 15px 0 0;
    color: #FFF;
    background-color: #3d8517;
  }

  @media (min-width: 993px) {
    #lesson .row .desktop-70 {
      width: 70%;
      width: calc((100% - 35px * 0.4285714285714286) / 1.4285714285714286);
    }
  }

  #lesson #actionList {
    margin-top: -16px;
    padding-bottom: 0px;
  }

  #lesson .removeBrs br {
    display: none;
  }

  #lesson .action .title {
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: 400;
    display: inline-block;
  }

  #lesson .action {
    padding: 16px 16px;
    border-left: 4px solid;
    margin-bottom: 1px;
    margin-left: -16px;
  }

  #lesson .action:nth-child(1) {
    border-color: #F58923;
  }

  #lesson .action:nth-child(2n) {
    border-color: #7CBE30;
  }

  #lesson .action:nth-child(3n) {
    border-color: #0179d5
  }

  #lesson .title h1 {
    margin-bottom: 12px !important;
  }

  #lesson .marginBottom {
    margin-bottom: 24px;
  }

  #lesson h1 {
    font-weight: 500;
  }

  #lesson h2, #lesson h3, #lesson h4, #lesson h5 {
    font-weight: 300;
    margin-top: 0px;
    color: #0179d5;
    margin-bottom: 16px;
  }

  #lesson div#sidedish p:last-child {
    margin-bottom: 16px;
  }

  #lesson .subTitle {
    font-size: 16px;
    font-weight: 400;
    color: #9B9B9B;
    margin-bottom: 16px;
  }

  #lesson .subTitle p {
    margin-bottom: 0px;
    padding-bottom: 0px;
  }

  #lesson .video {
    height: 416px;
  }
</style>



// WEBPACK FOOTER //
// Lesson.vue?1d02f8b6